import SectionSkeleton from "../../../components/ui/SectionSkeleton"
import { Box, Container, Link, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { Link as NavLink } from "react-router-dom"
import { Fragment, lazy, Suspense } from "react"
import Images from "../../../assets/js/Images"
import { obj1, obj2, obj4, obj5, obj6, table1 } from "./data"

const TopBannerA = lazy(() => import("../../../components/common/TopBannerA"))

function CookiesPolicy() {
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerA
          heading="Cookie Policy"
          currentPage="Cookie Policy"
          bannerImg={Images?.privacyPolicy}
        />
      </Suspense>

      <Box sx={{ py: 6 }}>
        <Container maxWidth={false} fixed>
          <Stack sx={{ maxWidth: "1100px", mx: "auto" }} spacing={4}>
            <Box>
              <Typography
                mb={2}
                fontSize={28}
                fontWeight="700"
                color="other.color1"
              >Cookie Policy for InnerPal.com
              </Typography>
              <Typography
                mb={3}
                fontWeight="500"
                color="other.color1"
              ><b>Effective Date: </b>07/31/2026
              </Typography>
              <Typography
                fontSize={18}
                color="other.color1"
              >This Cookie Policy explains how InnerPal.com ("we," "us," "our") uses cookies and similar technologies when you visit <Link
                target="_blank"
                fontWeight="500"
                component={NavLink}
                to="https://www.innerpal.com/"
              >www.innerpal.com
                </Link>. By continuing to browse our platform, you agree to our use of cookies as described below.
              </Typography>
            </Box>

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >{obj1?.title}
              </Typography>
              <Typography
                mb={2}
                fontWeight="500"
                color="other.color1"
              >{obj1?.subTitle}
              </Typography>
            </Box>

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >{obj2?.title}
              </Typography>
              <Typography
                mb={2}
                fontWeight="500"
                color="other.color1"
              >{obj2?.subTitle}
              </Typography>
              <Box component="ul">
                {obj2?.list?.map((item, j) => (
                  <Typography
                    mb={1}
                    key={j}
                    component="li"
                    color="other.color2"
                  >
                    {item?.key && (
                      <>
                        <strong>{item?.key}</strong><br />
                      </>
                    )}
                    {item?.summary}
                  </Typography>
                ))}
              </Box>
            </Box>

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >3. Types of Cookies We Use
              </Typography>
              <Box
                sx={{
                  display: "inline-block",
                  width: "100%",
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: "6px",
                  overflow: "hidden"
                }}
              >
                <Table
                  sx={{
                    "td,th": {
                      fontFamily: "Poppins",
                      color: "other.color1"
                    }
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "action.hover" }}>
                      {["Type of Cookie", "Purpose"]?.map((th, i) => (
                        <TableCell
                          key={i}
                          sx={{
                            fontWeight: "700",
                            borderRight: i === 0 ? "1px solid" : "none",
                            borderColor: "divider",
                          }}
                        >{th}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {table1?.map((td, i) => (
                      <TableRow key={i} sx={{ "td": { borderBottomColor: i === table1?.length - 1 ? "transparent" : "divider" } }}>
                        <TableCell sx={{ borderRight: "1px solid", borderColor: "divider", fontWeight: "600" }}>{td?.type}</TableCell>
                        <TableCell>{td?.purpose}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Box>

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >{obj4?.title}
              </Typography>
              <Typography
                mb={2}
                fontWeight="500"
                color="other.color1"
              >{obj4?.subTitle}
              </Typography>
              <Box component="ul">
                {obj4?.list?.map((item, j) => (
                  <Typography
                    mb={1}
                    key={j}
                    component="li"
                    color="other.color2"
                  >{item?.summary}
                  </Typography>
                ))}
              </Box>
              <Typography
                mt={1}
                fontWeight="500"
                color="other.color1"
              >{obj4?.otherTitle}
              </Typography>
            </Box>

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >{obj5?.title}
              </Typography>
              <Typography
                mb={1}
                fontWeight="500"
                color="other.color1"
              >{obj5?.subTitle}
              </Typography>
              <Typography
                mb={1}
                color="other.color2"
              >{obj5?.subTitle1}
              </Typography>
              <Typography
                mb={2}
                fontWeight="600"
                color="other.color1"
              >{obj5?.subTitle2}
              </Typography>
              <Box component="ul">
                {obj5?.links?.map((item, j) => (
                  <Typography
                    mb={1}
                    key={j}
                    component="li"
                    color="other.color2"
                  >
                    <Link
                      target="_blank"
                      fontWeight="500"
                      to={item?.path}
                      component={NavLink}
                    >{item?.name}
                    </Link>
                  </Typography>
                ))}
              </Box>
            </Box>

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >{obj6?.title}
              </Typography>
              <Typography
                fontWeight="500"
                color="other.color1"
              >{obj6?.subTitle}
              </Typography>
            </Box>

            <Box>
              <Typography
                mb={2}
                fontSize={24}
                component="h4"
                fontWeight="700"
                color="other.color1"
              >7. Contact Us
              </Typography>
              <Typography
                color="other.color2"
              >If you have any questions regarding our Cookie Policy, please reach out to us:
              </Typography>
              <Typography
                mt={1}
                fontSize={20}
                fontWeight="600"
                color="other.color1"
              >InnerPal.com
              </Typography>
              <Typography
                color="other.color1"
              ><strong>Email:</strong> <Link
                target="_blank"
                fontWeight="500"
                component={NavLink}
                to="mailto:support@innerpal.com"
              >support@innerpal.com
                </Link>
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Box>
    </Fragment>
  )
}

export default CookiesPolicy